import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import Loading from "../../components/Loading/Loading";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import TableAdmins from "./TableAdmins/TableAdmins";
import { useDispatch, useSelector } from "react-redux";
import { getAllAdminsAPI } from "../../services/users/Admins";
import { handleError } from "../../utils/handleError";
import toast from "react-hot-toast";
import { setLisAdmins } from "../../redux/slice/usersSlice";
import CreateAdminModal from "./ModalAdmin";

const UsersAdmins = () => {
  const { listAllAdmins } = useSelector((state) => state.usersReducer);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const getAllAdmins = async () => {
      try {
        const listAdmins = await getAllAdminsAPI();
        // console.log("Lista de admins", listAdmins);

        dispatch(setLisAdmins({ listAllAdmins: listAdmins ?? [] }));
        setLoading(false);
      } catch (error) {
        const { message } = handleError(error);
        dispatch(setLisAdmins({ listAllAdmins: [] }));
        setLoading(false);
        toast.error(`No se pudo obtener la información. \n ${message}`);
      }
    };
    getAllAdmins();
  }, [dispatch]);
  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <Loading loading={loading} />
      <CreateAdminModal
        onClose={() => setOpen(false)}
        open={open}
        setLoading={setLoading}
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}
      >
        <Typography variant="h5">Administradores</Typography>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          startIcon={<AdminPanelSettingsIcon />}
          onClick={() => {
            setOpen(true);
          }}
        >
          Agregar administrador
        </Button>
      </Box>
      <TableAdmins setLoading={setLoading} rows={listAllAdmins ?? []} />
    </Box>
  );
};

export default UsersAdmins;
